import React, { useState, useEffect } from "react";
import HostNameField from "./HostNameField";
import IpField from "./IpField";
import DeviceTypeField from "./DeviceTypeField";
import GroupField from "./GroupField";
import ConnectionTypeRadio from "./ConnectionTypeRadio";
import CriticalityField from "./CriticalityField";
import TagsField from "./TagsField";
import PortField from "./PortField";
import MsbConfigField from "./MsbConfigField";
import * as deviceService from "../../devices/deviceService";
import { connect } from "react-redux";
import { debug } from "../../utils";
import HealthMonitorIntervalField from "./HealthMonitorIntervalField";
import EnableSystemRemediationField from "./EnableSystemRemediationField";
import { ConnectionTypeFieldset } from "./ConnectionTypeSection";
import { AlertCircle, Key, Network } from "lucide-react";

function AddDeviceStep1({ disabled, deviceTypeId, connectionType, hostName, mngtIpAddress }) {

    //Added By Octopus DevTeam November 18,2022

    const [selectedDeviceType, setSelectedDeviceType] = useState(null);
    const [selectedConnectionType, setSelectedConnectionType] = useState(null);
    //const [enableSystemRemediation, setEnableSystemRemediation] = useState(null);

    // const fetchDeviceType = async () => {
    //     try {
    //         const deviceTypes = await deviceService.loadDeviceTypes();
    //         const getDeviceType = deviceTypes.find(e => e.id === deviceTypeId);
    //         if (getDeviceType) {
    //             setSelectedDeviceType(getDeviceType.name);
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //     }
    // };

    useEffect(() => {  
        async function fetchDeviceType () {
            try {
                const deviceTypes = await deviceService.loadDeviceTypes();
                const getDeviceType = deviceTypes.find(e => e.id === parseInt(deviceTypeId));
                if (getDeviceType) {
                    setSelectedDeviceType(getDeviceType.name);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };      
        
        fetchDeviceType();
    }, [deviceTypeId]);

    useEffect(() => {
        setSelectedConnectionType(connectionType);
    }, [connectionType]);

    const isMonitorIntervalDisabled = disabled || !hostName.trim();
    const isDeviceIpDisabled = disabled || selectedConnectionType === "M365";


    function getWinRmRequirements() {

        const commands = [
            `> winrm quickconfig`,
            `> winrm set winrm/config/service/Auth '@{Basic="true"}'`,
            `> winrm set winrm/config/service '@{AllowUnencrypted="true"}'`
        ]

//         corrected ones: 
// winrm set winrm/config/service/Auth '@{Basic="true"}'
// winrm set winrm/config/service '@{AllowUnencrypted="true"}'

        return (
            <div className="col lg-5 oct_paddingtop-six modal-v2-winrm-box">
                <span>WinRM connection requirements:</span>
                <ul className="ml-3">
                    <li>Basic authentication must be allowed.</li>
                    <li>Unencrypted data transfer must be allowed.</li>
                </ul>
                <span>On the remote host, open a PowerShell and paste in the following lines:</span>
                <ul className="mt-3 list-unstyled border p-1">
                    {commands.map((command, index) => <li key={index} className="text-sm">{command}</li>)}
                </ul>
            </div>
        )
    }

    return ( 
        <form className="oct_form pt-4 px-4 modal-v2-form modal-v2-form-step1" autoComplete="off">
            <div className="oct_adddevice-title modal-v2-title">Add Device Wizard - STEP 1: Network Configurtion</div>
            <div className="oct_hint modal-v2-hint">
                <AlertCircle className="modal-v2-hint-icon" size={20} />
                <div className="modal-v2-hint-copy">
                    <span className="modal-v2-hint-title">Bulk Device Import:</span>
                    <span className="modal-v2-hint-text">Use ranges (192.168.1.10-25) or comma-separated values (192.168.1.10,192.168.1.11) in the IP field.</span>
                </div>
            </div>
            <div className="modal-v2-section">
                <div className="modal-v2-section-heading">
                    <span className="modal-v2-section-heading-icon">
                        <Network size={20} />
                    </span>
                    <h3 className="modal-v2-section-heading-text">Network Configuration</h3>
                </div>
                <div className="modal-v2-section-card">
                    <div className="row modal-v2-form-grid">
                        <div className="col-md-6 modal-v2-grid-field">
                            <DeviceTypeField disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <HostNameField disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <IpField disabled={isDeviceIpDisabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <PortField disabled={isDeviceIpDisabled} />
                        </div>
                        {/* <div className="col-md-6 modal-v2-grid-field">
                            <DeviceTypeField disabled={disabled} />
                        </div> */}
                        <div className="col-md-6 modal-v2-grid-field">
                            <GroupField disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <CriticalityField disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <TagsField disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <MsbConfigField disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-grid-field">
                            <HealthMonitorIntervalField disabled={isMonitorIntervalDisabled} />
                        </div>
                        <div className="col-12 modal-v2-grid-field">
                            <EnableSystemRemediationField/>
                        </div>
                        <div className="col-12 modal-v2-grid-field">
                            <ConnectionTypeRadio disabled={disabled} selectedDeviceType={selectedDeviceType} />
                        </div>                       
                    </div>
                </div>
            </div>
            <div className="modal-v2-section">
                <div className="modal-v2-section-heading">
                    <span className="modal-v2-section-heading-icon">
                        <Key size={20} />
                    </span>
                    <h3 className="modal-v2-section-heading-text">Authentication</h3>
                </div>
                <div className="modal-v2-section-card modal-v2-auth-card">
                    <ConnectionTypeFieldset connectionType={connectionType} disabled={disabled} />
                    {
                        (selectedConnectionType !== null && selectedConnectionType.toLowerCase().includes("winrm")) ?
                            getWinRmRequirements() : null
                    }
                </div>
            </div>
        </form>
    )
}

function mapStateToProps(state) {
    debug("AddDeviceStep1 mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        connectionType: addDeviceModal.connectionType,
        deviceTypeId: addDeviceModal.deviceTypeId,
        hostName: addDeviceModal.hostName || "",
        mngtIpAddress: addDeviceModal.mngtIpAddress || "",
    }
}

export default connect(mapStateToProps)(AddDeviceStep1);
